import { FetchData } from 'internalLibrary';

export const fetchData: FetchData = async (path, customOptions) => {
  const defaultHeaders = {
    'Content-Type': 'application/json',
    ...(sessionStorage.getItem('token') && {
      Authorization: `Basic ${sessionStorage.getItem('token')}`,
    }),
  };

  const options = {
    ...customOptions,
    headers: new Headers({
      ...defaultHeaders,
      ...customOptions.headers,
    }),
  };

  const url = `${process.env.REACT_APP_WEB_API}${path}`;

  const response = await fetch(url, options);
  if ((response.status === 401 || response.status === 403) && window.Cypress) {
    // Return an empty object during cypress tests when a request hasn't been intercepted in tests
    return {} as any;
  }

  if (response.status === 401) {
    sessionStorage.clear();
  }

  if (!response.ok) {
    throw new Error(`${response.status}`);
  }

  try {
    let data;
    if (options.headers.get('Content-Type') === 'text/html') {
      data = await response.text();
    } else if (options.headers.get('Content-Type') === 'application/pdf') {
      data = await response.blob();
    } else {
      data = await response.json();
    }
    return data;
  } catch {
    // If response doesn't have content return undefined;
    return undefined as any;
  }
};
